import { http } from '../../../utils'

import { AxiosResponse } from 'axios'

export const ActionTypes = {
  GET_LEDGER_SUMMARY_DATA: 'GET_LEDGER_SUMMARY_DATA'
}

export const getLedgerSummaryData = (partyId?: string) => {
  let url = '/charts/pvt/ledger_summary_v2'
  if (partyId) {
    url = '/charts/pvt/ledger_summary_v2?party_id=' + partyId
  }
 
  return http
    .get(url)
    .then((response: AxiosResponse) => response)
}

export const getLedgerSummaryDataAction = (partyId?: string) => ({
  type: ActionTypes.GET_LEDGER_SUMMARY_DATA,
  promise: getLedgerSummaryData(partyId),
})
